import { DbHelper } from "@app/shared/model/db-object.model";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { ClareServicePlan } from "./clare-service-plan";

/**
 * @description A model for account service plan subscriptions
 */
export interface ClareServiceSubscription {
    id: number;
    projectId: number;
    servicePlanId: number;
    startDate: string;
    endDate: string;
}

/**
 * @description A model for the database side of the account service plan subscription
 */
export interface ClareServiceSubscriptionData {
    id: number;
    project_id: number;
    service_plan_id: number;
    start_date: string;
    end_date: string;
}

export class ClareServiceSubscriptionHelper extends DbHelper<ClareServiceSubscription, ClareServiceSubscriptionData> {
    static dbTypeName = "Service Plan Subscription";
    static dbTypeNamePlural = "Service Plan Subscriptions";

    static readonly importMap: ImportMap<ClareServiceSubscription, ClareServiceSubscriptionData> = [
        { i: "id", o: "id" },
        { i: "project_id", o: "projectId" },
        { i: "service_plan_id", o: "servicePlanId" },
        { i: "start_date", o: "startDate" },
        { i: "end_date", o: "endDate" },
    ] as const;

    static fromDbObject(data: ClareServiceSubscriptionData): ClareServiceSubscription {
        return ClassImporterExporter.importObject(data, ClareServiceSubscriptionHelper.importMap);
    }

    static toDbObject(data: ClareServiceSubscription): ClareServiceSubscriptionData {
        return ClassImporterExporter.exportObject(data, ClareServiceSubscriptionHelper.importMap);
    }

    /**
     * @description A helper method to determine if a feature is enabled as part of the subscription
     * @static
     */
    static isFeatureEnabled(servicePlan: ClareServicePlan, featureKey: string): boolean {
        if (!servicePlan) {
            return false;
        }

        const feature = servicePlan.features.find(f => f.featureKey === featureKey);
        return !!feature;
    }

    importMap: ImportMap<ClareServiceSubscription, ClareServiceSubscriptionData> = ClareServiceSubscriptionHelper.importMap;
}
